import React from 'react'
import {
  useResourceContext,
  Button,
  useRecordContext, 
  useTranslate
} from 'react-admin'
import { Link } from 'react-router-dom';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export const VersionButton = (props) => {
    const record = useRecordContext();
    const translate = useTranslate()
    const resource = useResourceContext(props);
    if (!record) return null;
  
    return (
      <Button
          component={Link}
          to={`/${resource}/${record.id}/versions`}
          label={''}
          onClick={e => e.stopPropagation()}
          title={translate('ra.action.go_revision')}
        >
          <Inventory2OutlinedIcon/>
        </Button>
    )
  }